export default __webpack_public_path__ + "5938ddaefe1d0f380975c8ea16a68b10.png";